/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreMessageResponseDto } from '../models/core-message-response-dto';
import { CoreProjectLightDto } from '../models/core-project-light-dto';
import { projectMetricsControllerGetVacationMetrics } from '../fn/projects/project-metrics-controller-get-vacation-metrics';
import { ProjectMetricsControllerGetVacationMetrics$Params } from '../fn/projects/project-metrics-controller-get-vacation-metrics';
import { CoreProjectResponseDto } from '../models/core-project-response-dto';
import { projectsControllerCreate } from '../fn/projects/projects-controller-create';
import { ProjectsControllerCreate$Params } from '../fn/projects/projects-controller-create';
import { projectsControllerDelete } from '../fn/projects/projects-controller-delete';
import { ProjectsControllerDelete$Params } from '../fn/projects/projects-controller-delete';
import { projectsControllerFindAll } from '../fn/projects/projects-controller-find-all';
import { ProjectsControllerFindAll$Params } from '../fn/projects/projects-controller-find-all';
import { projectsControllerFindByCode } from '../fn/projects/projects-controller-find-by-code';
import { ProjectsControllerFindByCode$Params } from '../fn/projects/projects-controller-find-by-code';
import { projectsControllerFindById } from '../fn/projects/projects-controller-find-by-id';
import { ProjectsControllerFindById$Params } from '../fn/projects/projects-controller-find-by-id';
import { projectsControllerFindLight } from '../fn/projects/projects-controller-find-light';
import { ProjectsControllerFindLight$Params } from '../fn/projects/projects-controller-find-light';
import { projectsControllerSoftDeleteAttachment } from '../fn/projects/projects-controller-soft-delete-attachment';
import { ProjectsControllerSoftDeleteAttachment$Params } from '../fn/projects/projects-controller-soft-delete-attachment';
import { projectsControllerUpdate } from '../fn/projects/projects-controller-update';
import { ProjectsControllerUpdate$Params } from '../fn/projects/projects-controller-update';
import { vacationBillingControllerApproveVacationPayment } from '../fn/projects/vacation-billing-controller-approve-vacation-payment';
import { VacationBillingControllerApproveVacationPayment$Params } from '../fn/projects/vacation-billing-controller-approve-vacation-payment';
import { CoreVacationMetricsResponseDto } from '../models/core-vacation-metrics-response-dto';

@Injectable({ providedIn: 'root' })
export class CoreProjectsService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectMetricsControllerGetVacationMetrics()` */
  static readonly ProjectMetricsControllerGetVacationMetricsPath = '/o2-core/projects/{tenant}/{id}/metrics';

  /**
   * Vacation (T&M) metrics for a project.
   *
   * Aggregates every timesheet of the project by snapshotLevel and returns value, cost and margin. Returns zero buckets for non-vacation projects.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectMetricsControllerGetVacationMetrics()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectMetricsControllerGetVacationMetrics$Response(params: ProjectMetricsControllerGetVacationMetrics$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreVacationMetricsResponseDto>> {
    const obs = projectMetricsControllerGetVacationMetrics(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Vacation (T&M) metrics for a project.
   *
   * Aggregates every timesheet of the project by snapshotLevel and returns value, cost and margin. Returns zero buckets for non-vacation projects.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectMetricsControllerGetVacationMetrics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectMetricsControllerGetVacationMetrics(params: ProjectMetricsControllerGetVacationMetrics$Params, context?: HttpContext): Observable<CoreVacationMetricsResponseDto> {
    const resp = this.projectMetricsControllerGetVacationMetrics$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreVacationMetricsResponseDto>): CoreVacationMetricsResponseDto => r.body)
    );
  }

  /** Path part for operation `projectsControllerFindAll()` */
  static readonly ProjectsControllerFindAllPath = '/o2-core/projects/{tenant}';

  /**
   * Get all projects for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindAll$Response(params: ProjectsControllerFindAll$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectResponseDto>>> {
    const obs = projectsControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all projects for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindAll(params: ProjectsControllerFindAll$Params, context?: HttpContext): Observable<Array<CoreProjectResponseDto>> {
    const resp = this.projectsControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectResponseDto>>): Array<CoreProjectResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectsControllerCreate()` */
  static readonly ProjectsControllerCreatePath = '/o2-core/projects/{tenant}';

  /**
   * Create a new project with optional tasks and subtasks.
   *
   * Creates a project with automatic estimatedHours calculation. If tasks array is provided, batch-creates all tasks and subtasks efficiently.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerCreate$Response(params: ProjectsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
    const obs = projectsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new project with optional tasks and subtasks.
   *
   * Creates a project with automatic estimatedHours calculation. If tasks array is provided, batch-creates all tasks and subtasks efficiently.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerCreate(params: ProjectsControllerCreate$Params, context?: HttpContext): Observable<CoreProjectResponseDto> {
    const resp = this.projectsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectResponseDto>): CoreProjectResponseDto => r.body)
    );
  }

  /** Path part for operation `projectsControllerFindLight()` */
  static readonly ProjectsControllerFindLightPath = '/o2-core/projects/light/{tenant}';

  /**
   * Get light project data for a tenant (optimized).
   *
   * Returns minimal project data (_id, tenant, code, projectName, status) with optional status and customer filters. Optimized for performance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerFindLight()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindLight$Response(params: ProjectsControllerFindLight$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectLightDto>>> {
    const obs = projectsControllerFindLight(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get light project data for a tenant (optimized).
   *
   * Returns minimal project data (_id, tenant, code, projectName, status) with optional status and customer filters. Optimized for performance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerFindLight$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindLight(params: ProjectsControllerFindLight$Params, context?: HttpContext): Observable<Array<CoreProjectLightDto>> {
    const resp = this.projectsControllerFindLight$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectLightDto>>): Array<CoreProjectLightDto> => r.body)
    );
  }

  /** Path part for operation `projectsControllerFindById()` */
  static readonly ProjectsControllerFindByIdPath = '/o2-core/projects/{tenant}/id/{id}';

  /**
   * Get a project by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindById$Response(params: ProjectsControllerFindById$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
    const obs = projectsControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a project by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindById(params: ProjectsControllerFindById$Params, context?: HttpContext): Observable<CoreProjectResponseDto> {
    const resp = this.projectsControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectResponseDto>): CoreProjectResponseDto => r.body)
    );
  }

  /** Path part for operation `projectsControllerDelete()` */
  static readonly ProjectsControllerDeletePath = '/o2-core/projects/{tenant}/id/{id}';

  /**
   * Delete a project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerDelete$Response(params: ProjectsControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
    const obs = projectsControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerDelete(params: ProjectsControllerDelete$Params, context?: HttpContext): Observable<CoreProjectResponseDto> {
    const resp = this.projectsControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectResponseDto>): CoreProjectResponseDto => r.body)
    );
  }

  /** Path part for operation `projectsControllerUpdate()` */
  static readonly ProjectsControllerUpdatePath = '/o2-core/projects/{tenant}/id/{id}';

  /**
   * Update a project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerUpdate$Response(params: ProjectsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
    const obs = projectsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerUpdate(params: ProjectsControllerUpdate$Params, context?: HttpContext): Observable<CoreProjectResponseDto> {
    const resp = this.projectsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectResponseDto>): CoreProjectResponseDto => r.body)
    );
  }

  /** Path part for operation `projectsControllerFindByCode()` */
  static readonly ProjectsControllerFindByCodePath = '/o2-core/projects/{tenant}/by-code/{code}';

  /**
   * Get a project by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerFindByCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindByCode$Response(params: ProjectsControllerFindByCode$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
    const obs = projectsControllerFindByCode(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a project by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerFindByCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerFindByCode(params: ProjectsControllerFindByCode$Params, context?: HttpContext): Observable<CoreProjectResponseDto> {
    const resp = this.projectsControllerFindByCode$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectResponseDto>): CoreProjectResponseDto => r.body)
    );
  }

  /** Path part for operation `projectsControllerSoftDeleteAttachment()` */
  static readonly ProjectsControllerSoftDeleteAttachmentPath = '/o2-core/projects/{tenant}/{projectId}/attachments';

  /**
   * Soft delete a project attachment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerSoftDeleteAttachment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerSoftDeleteAttachment$Response(params: ProjectsControllerSoftDeleteAttachment$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
    const obs = projectsControllerSoftDeleteAttachment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Soft delete a project attachment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerSoftDeleteAttachment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerSoftDeleteAttachment(params: ProjectsControllerSoftDeleteAttachment$Params, context?: HttpContext): Observable<void> {
    const resp = this.projectsControllerSoftDeleteAttachment$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vacationBillingControllerApproveVacationPayment()` */
  static readonly VacationBillingControllerApproveVacationPaymentPath = '/o2-core/projects/{tenant}/{id}/approve-vacation-payment';

  /**
   * Approve a vacation payment with optional billable-flag updates.
   *
   * Atomically applies billable updates, locks the period, and dispatches a payment refresh to sales. One round-trip from the review dialog.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vacationBillingControllerApproveVacationPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vacationBillingControllerApproveVacationPayment$Response(params: VacationBillingControllerApproveVacationPayment$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreMessageResponseDto>> {
    const obs = vacationBillingControllerApproveVacationPayment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Approve a vacation payment with optional billable-flag updates.
   *
   * Atomically applies billable updates, locks the period, and dispatches a payment refresh to sales. One round-trip from the review dialog.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vacationBillingControllerApproveVacationPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vacationBillingControllerApproveVacationPayment(params: VacationBillingControllerApproveVacationPayment$Params, context?: HttpContext): Observable<CoreMessageResponseDto> {
    const resp = this.vacationBillingControllerApproveVacationPayment$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreMessageResponseDto>): CoreMessageResponseDto => r.body)
    );
  }

}
